// extracted by mini-css-extract-plugin
export default {"container":"Section_container__4M4lK","header":"Section_header__lIdRr","title":"Section_title__IKTYp","switch":"Section_switch__6dj9+","description":"Section_description__0IGaB"};